import { fetchGetCreditCardTellMoneyUserConsentByConsentId } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { getTellMoneyUserConsentByConsentIdKey } from './queryKeys';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useGetTellMoneyUserConsentByConsentId = (consentId: string) => {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: getTellMoneyUserConsentByConsentIdKey(stateKey, consentId),
        queryFn: () =>
            fetchGetCreditCardTellMoneyUserConsentByConsentId({
                stateKey,
                consentId
            }),
        suspense: true,
        enabled: !!consentId
    });

    return data!;
};
